import * as Sentry from "@sentry/react";

if (import.meta.env.VITE_DEVELOPMENT !== "development") {
	Sentry.init({
		dsn: "https://b4de0e5f532c5266bb1ad033857ff0eb@errorreporting.unified-cloud.eu/72",
		release: "2026.01.21 (260121.075602-662b729)",
		integrations: [Sentry.browserTracingIntegration()],
		tracesSampleRate: 0.05 // low rate in order not to slow down production
	});
}
